import { useContext } from 'react';
import { DataTableContainerContext, IDataTableContext } from './DataTable';
import Row from './Row';
const Rows = () => {
    const { pagedData, getTableBodyProps, rows, prepareRow, props, selectedCells, setSelectedCells,
        setIsSelecting, setStartCell, isSelecting, startCell
    } = useContext<IDataTableContext>(DataTableContainerContext);
    const { selection } = props;

    // Bắt đầu chọn vùng
    const handleMouseDown = (rowIndex: number, colIndex: number) => {
        setIsSelecting(true);
        setStartCell({ rowIndex, colIndex });
        setSelectedCells(new Set([`${rowIndex}-${colIndex}`]));
    };
    // Kéo chuột để chọn vùng
    const handleMouseMove = (rowIndex: number, colIndex: number) => {
        if (isSelecting && startCell) {
            const { rowIndex: startRow, colIndex: startCol } = startCell;
            const minRow = Math.min(startRow, rowIndex);
            const maxRow = Math.max(startRow, rowIndex);
            const minCol = Math.min(startCol, colIndex);
            const maxCol = Math.max(startCol, colIndex);

            const newSelectedCells = new Set();
            for (let r = minRow; r <= maxRow; r++) {
                for (let c = minCol; c <= maxCol; c++) {
                    newSelectedCells.add(`${r}-${c}`);
                }
            }
            setSelectedCells(newSelectedCells);
        }
    };

    return (
        <>
            {pagedData.length > 0 && (
                <tbody {...getTableBodyProps()}>
                    {rows.map((row: any, rowIndex: number) => {
                        prepareRow(row);
                        return (
                            <Row
                                focusedRow={props.focusedRow}
                                focusedCell={props.focusedCell}
                                handleMouseDown={handleMouseDown}
                                handleMouseMove={handleMouseMove}
                                row={row}
                                rowIndex={rowIndex}
                                selectedCells={selectedCells}
                                selection={selection}
                                checkDontSaveChange={props.checkDontSaveChange}
                                key={rowIndex}
                                onFocuseCellChanged={props.onFocuseCellChanged}
                                rangeSelection={props.rangeSelection}

                            />
                        );

                       
                    })}
                </tbody>
            )}
            {pagedData.length <= 0 && (
                <tbody>
                    <tr>
                        <td colSpan={props.columns.length}>
                            {props.emptyComponent}
                        </td>
                    </tr>
                </tbody>
            )}
        </>
    );
};

export default Rows;